export const onlyCharacters = (unformattedString) =>
  unformattedString?.replaceAll(/[\d]/g, '');
